import { render, staticRenderFns } from "./GanttDetailDialog.vue?vue&type=template&id=9aa35708&scoped=true&lang=pug&"
import script from "./GanttDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./GanttDetailDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa35708",
  null
  
)

export default component.exports